import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "device-details-events" }
const _hoisted_2 = { class: "columns h-100" }
const _hoisted_3 = { class: "column h-100 is-9" }
const _hoisted_4 = { class: "column h-100 is-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chart_station_events = _resolveComponent("chart-station-events")!
  const _component_station_events_timeline = _resolveComponent("station-events-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_chart_station_events, {
          station: _ctx.station,
          since: _ctx.since,
          before: _ctx.before,
          events: _ctx.events
        }, null, 8 /* PROPS */, ["station", "since", "before", "events"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_station_events_timeline, {
          station: _ctx.station,
          since: _ctx.since,
          before: _ctx.before,
          events: _ctx.events
        }, null, 8 /* PROPS */, ["station", "since", "before", "events"])
      ])
    ])
  ]))
}